import { Panel } from "primereact/panel";
import React, { useRef, useState } from "react";
import {
  FaChevronDown,
  FaChevronUp,
  FaMapMarkerAlt,
  FaClock,
  FaBriefcase,
  FaDollarSign,
} from "react-icons/fa";

const PanelComponent = ({ job, setDisplayApplication }) => {
  const panelRef = useRef(null);
  const [collapsed, setCollapsed] = useState(true);

  const renderPanelHeader = (job) => {
    return (
      <div className="p-panel-header bg-white p-6 cursor-pointer hover:bg-gray-50 transition-colors duration-200">
        <div
          className="jobRole-card flex flex-col lg:flex-row lg:justify-between lg:items-center w-full space-y-4 lg:space-y-0"
          onClick={() => {
            panelRef.current.toggle();
          }}
        >
          {/* Main Job Info */}
          <div className="flex-1 space-y-3">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-gray-900 mb-2 group-hover:text-brand transition-colors">
                  {job.attributes.jobRole}
                </h3>
                <p className="text-gray-600 text-lg leading-relaxed">
                  {job.attributes.shortDescription}
                </p>
              </div>
              <div className="ml-4 flex-shrink-0">
                <div className="w-10 h-10 bg-brand/10 rounded-full flex items-center justify-center group-hover:bg-brand/20 transition-colors">
                  {collapsed ? (
                    <FaChevronDown className="text-brand" />
                  ) : (
                    <FaChevronUp className="text-brand" />
                  )}
                </div>
              </div>
            </div>

            {/* Job Meta Info */}
            <div className="flex flex-wrap gap-4 text-sm">
              <div className="flex items-center space-x-2 text-gray-600">
                <FaMapMarkerAlt className="text-brand" />
                <span className="font-medium">{job.attributes.location}</span>
              </div>
              <div className="flex items-center space-x-2 text-gray-600">
                <FaClock className="text-brand" />
                <span className="font-medium">{job.attributes.workType}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100">
      <Panel
        ref={panelRef}
        headerTemplate={renderPanelHeader(job)}
        toggleable
        collapsed
        onCollapse={() => setCollapsed(true)}
        onExpand={() => {
          setCollapsed(false);
        }}
      >
        <div className="p-panel-content p-0">
          <div className="bg-gray-50 p-8">
            <div className="flex flex-col lg:flex-row gap-8">
              {/* Job Description */}
              <div className="flex-1 space-y-6">
                <div>
                  <h4 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                    <FaBriefcase className="text-brand mr-3" />
                    Job Description
                  </h4>
                  <div
                    className="prose prose-gray max-w-none text-gray-700 leading-relaxed"
                    dangerouslySetInnerHTML={{
                      __html: job.attributes.description,
                    }}
                  ></div>
                </div>
              </div>

              {/* Job Details Sidebar */}
              <div className="lg:w-80 space-y-6">
                <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
                  <h4 className="text-lg font-bold text-gray-900 mb-4">
                    Job Details
                  </h4>

                  <div className="space-y-4">
                    <div className="flex items-start space-x-3">
                      <div className="w-8 h-8 bg-brand/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                        <FaBriefcase className="text-brand text-sm" />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-gray-600">
                          Experience Level
                        </p>
                        <p className="text-gray-900 font-medium">
                          {job.attributes.experience}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <div className="w-8 h-8 bg-brand/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                        <FaDollarSign className="text-brand text-sm" />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-gray-600">
                          Compensation
                        </p>
                        <p className="text-gray-900 font-medium">
                          {job.attributes.compensation}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <div className="w-8 h-8 bg-brand/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                        <FaMapMarkerAlt className="text-brand text-sm" />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-gray-600">
                          Location
                        </p>
                        <p className="text-gray-900 font-medium">
                          {job.attributes.location}
                        </p>
                      </div>
                    </div>

                    <div className="flex items-start space-x-3">
                      <div className="w-8 h-8 bg-brand/10 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                        <FaClock className="text-brand text-sm" />
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-gray-600">
                          Work Type
                        </p>
                        <p className="text-gray-900 font-medium">
                          {job.attributes.workType}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Apply Button */}
                <div className="bg-gradient-to-r from-brand to-primary-600 rounded-xl p-6 text-white">
                  <h4 className="text-lg font-bold mb-2">Ready to Apply?</h4>
                  <p className="text-white/90 text-sm mb-4">
                    Join our team and make a difference in the education
                    technology space.
                  </p>
                  <button
                    className="w-full bg-white text-brand font-bold py-3 px-6 rounded-lg hover:bg-gray-100 transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                    onClick={() => setDisplayApplication(true)}
                  >
                    Apply Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Panel>
    </div>
  );
};
export default PanelComponent;
